export default __webpack_public_path__ + "static/media/logo-us-guess.8e216871.svg";